import React, { Fragment } from 'react'
import {
  HashRouter,
  Switch,
  Route,
  Redirect,
  useHistory,
  useLocation,
} from 'react-router-dom'
import Helmet from 'react-helmet'
import { colors } from './components/theme'

import ErrorBoundary from './components/shared/error_boundary'
import ThemeWrapper from './components/theme'
import GlobalLayout from './components/layout/global_layout'
import Header from './components/layout/header'

import Overview from './components/overview/index'
import Documentation from './components/documentation/index'
import Search from './components/search/index'

export default class App extends React.Component {
  render() {
    return (
      <ThemeWrapper>
        <Helmet>
          <style type="text/css">
            {`
            * {
              margin: 0;
              padding: 0;
            }

            html, body {
              background: ${colors['grey-3']};
              color: ${colors['grey-9']};
              font-weight: 400;
              font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            }

            a:not([role='button']),
            a:not([role='button']):visited {
              color: var(--t-text-color-interaction-primary);
            }

            a:not([role='button']):hover,
            a:not([role='button']):visited:hover {
              color: var(--t-text-color-interaction-hover);
            }
          `}
          </style>
        </Helmet>
        <GlobalLayout>
          <ErrorBoundary>
            <Router>
              <Fragment>
                <Header />
                <Switch>
                  <Route path="/overview/" component={Overview} />
                  <Route
                    path="/apps/:appName/:version/vertices/:vertexId"
                    component={Documentation}
                  />
                  <Route
                    path="/apps/:appName/:version?"
                    component={Documentation}
                  />
                  <Route path="/search/:query/:app?" component={Search} />
                  <Redirect from="/" to="/overview/" />
                </Switch>
              </Fragment>
            </Router>
          </ErrorBoundary>
        </GlobalLayout>
      </ThemeWrapper>
    )
  }
}

function Router({ children }) {
  // `EnsureAnchorDecodedBeforeRendering` needs to be the top-level child
  // under `HashRouter`. it blocks rendering so no other `Routes` / `Redirects`
  // resolve until after it has ensured the path is decoded.
  return (
    <HashRouter>
      <EnsureAnchorDecodedBeforeRendering>
        {children}
      </EnsureAnchorDecodedBeforeRendering>
    </HashRouter>
  )
}

const ENCODED_HASH = encodeURIComponent('#')

function EnsureAnchorDecodedBeforeRendering({ children }) {
  const history = useHistory()
  const location = useLocation()

  // since we're using a `HashRouter`, react-router's already done the work
  // of translating `window.location.hash` to `location.pathname`. now, if
  // something has encoded the `#` of the intended anchor, we can go look for
  // it in the pathname.
  if (location.pathname.includes(ENCODED_HASH)) {
    let parts = location.pathname.split(ENCODED_HASH)

    const hash = parts.pop()
    const pathname = parts.join(ENCODED_HASH)

    history.replace({ ...location, pathname, hash })
  }

  return children
}
